'use strict';

var React = require('react');

var SvgAnalyticsFunnelMinor = function SvgAnalyticsFunnelMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.758 6.681a2.75 2.75 0 0 1 2.588-3.681h7.308a2.75 2.75 0 0 1 2.588 3.681l-3.06 8.5a2.75 2.75 0 0 1-2.588 1.819h-1.188a2.75 2.75 0 0 1-2.588-1.819l-3.06-8.5Zm2.588-2.181a1.25 1.25 0 0 0-1.176 1.673l.297.827h9.066l.298-.827a1.25 1.25 0 0 0-1.177-1.673h-7.308Zm.651 6.75-.99-2.75h7.986l-.99 2.75h-6.006Zm.54 1.5.693 1.923a1.25 1.25 0 0 0 1.176.827h1.188c.527 0 .998-.33 1.177-.827l.692-1.923h-4.926Z"
  }));
};
SvgAnalyticsFunnelMinor.displayName = "AnalyticsFunnelMinor";

exports.SvgAnalyticsFunnelMinor = SvgAnalyticsFunnelMinor;
